import OutreachLocationController from "./outreach_location_controller";

export default class extends OutreachLocationController {
  static values = { resources: Array, radius: Number };

  initializeGoogle() {
    super.initializeGoogle();
    const bounds = new google.maps.LatLngBounds();
    this.resourcesValue.forEach((resource, index) => {
      const point = resource.coordinates;
      if (!point || !this.map) return;
      const position = { lat: point.latitude, lng: point.longitude };
      bounds.extend(position);
      new google.maps.Marker({ map: this.map,
        position,
        label: String(index + 1), title: resource.name });
    });
    if (this.map && this.hasCurrentPoint()) {
      const circle = new google.maps.Circle({ map: this.map,
        center: { lat: this.currentLat(), lng: this.currentLng() },
        radius: this.radiusValue * 1609.34, fillOpacity: 0.06, strokeOpacity: 0.3 });
      this.map.fitBounds(circle.getBounds());
    } else if (this.map && !bounds.isEmpty()) {
      this.map.fitBounds(bounds);
    }
  }

  setPoint(lat, lng, zoom) {
    super.setPoint(lat, lng, zoom);
    this.setStatus(this.statusMessage("pending"));
  }

  placeChanged() {
    super.placeChanged();
    this.setStatus(this.statusMessage("pending"));
  }
}
